import { useEffect, useState } from "react";
import NotificationApi from "../../apis/notification.api";
import {
  AlertSvg,
  GreenProgressSvg,
  LinkSvg,
  NoticeSvg,
  ProgressSvg,
  ReportSvg,
} from "../../components/Assets";
import TopPageBack from "../../components/TopPageBack";
import {
  NOTIFICATION_TYPE,
  PAGE_NO,
  PAGE_SIZE,
} from "../../constants/AppConstants";
import AppUtils from "../../utils";
import Switch from "react-switch";

const Notification = function () {
  const [params, setParams] = useState({
    page_no: PAGE_NO,
    page_size: PAGE_SIZE,
  });
  const [notifications, setNotifications] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [receiveNotificationSetting,setReceiveNotificationSetting] = useState(false);

  const renderIcon = (type) => {
    switch (type) {
      case NOTIFICATION_TYPE.MONTHLY_REPORT:
        return ReportSvg;

      case NOTIFICATION_TYPE.APP_CONNECT_ISSUE:
        return LinkSvg;

      case NOTIFICATION_TYPE.GETTING_REVIEW_FAILED:
        return ProgressSvg;

      case NOTIFICATION_TYPE.GETTING_REVIEW_SUCCESS:
        return GreenProgressSvg;

      default:
        return NoticeSvg;
    }
  };

  const getNotifications = async () => {
    const { data } = await NotificationApi.get(params);
    if (data.data.notifications) {
      setNotifications(data.data.notifications);
      setTotalCount(data.data.total_cnt);
      setReceiveNotificationSetting(data.data.receiveNotificationSetting ==='Y'? true : false)
    }
  };
  const updateRead = async () => {
    const { data } = await NotificationApi.seen(params);
    if (data.data) {
     console.log(data);
    }
  };

  const onLoadEnd = async () => {
    if (notifications.length < totalCount) {
      const { data } = await NotificationApi.get({
        ...params,
        page_no: parseFloat(params.page_no) + 1,
      });
      console.log('data', data)
      setParams({
        ...params,
        page_no: parseFloat(params.page_no) + 1,
      });
      if (data.data.notifications) {
        const concatNotifications = notifications.concat(data.data.notifications);
        setNotifications(concatNotifications);
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop ===
        document.documentElement.offsetHeight
      ) {
        onLoadEnd();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [notifications]);

  useEffect(() => {
    getNotifications();
    updateRead();
  }, []);
  const handleChangeNotificationSetting =()=>{
    let payload = {receiveNotification: (!receiveNotificationSetting ? 'Y' : 'N')};
    NotificationApi.updateSetting(payload);
    setReceiveNotificationSetting(!receiveNotificationSetting);
  }
  return (
    <div>
      <TopPageBack>
        <b>알림함</b>
      </TopPageBack>
      <div className="p-5 flex flex-row justify-between bg-[#F8F9FC]">
        <span className="text-15 font-bold content-center">푸시 알림</span> 
        <span className="relative top-2"><Switch height={31} width={51} className="switch-center" offColor="#cfcfcf" onColor="#3451D7" uncheckedIcon={false} checkedIcon={false} onChange={handleChangeNotificationSetting} checked={receiveNotificationSetting} />
        </span>
      </div>
      {notifications.length > 0 ? (
        <>
          {/* <div className="flex justify-between items-center  bg-gray py-3 px-6 mb-5">
            <div className="text-darkblue text-15 font-bold">푸시 알림</div>
            <div>
              <label className="inline-flex items-center cursor-pointer">
                <input type="checkbox" defaultValue className="sr-only peer" />
                <div
                  className="relative w-[50px] h-7 
              bg-gray-200 rounded-full peer dark:bg-[#78788052] 
              peer-checked:after:translate-x-full 
              rtl:peer-checked:after:-translate-x-full 
              peer-checked:after:border-white after:content-[''] 
              after:absolute after:top-[2px] after:start-[1px] 
              after:bg-white after:border-gray-300 after:border 
              after:rounded-full after:h-6 after:w-6 after:transition-all 
              dark:border-gray-600 peer-checked:bg-[#037EDB]"
                />
              </label>
            </div>
          </div> */}
          <div  className="pb-16">
            {notifications.map((item, index) => (
              <div
                key={index}
                className="flex justify-between p-6 border-b border-1 border-[#E6EAF2]"
              >
                <div className="space-y-3">
                  <div className="text-datesub text-xs">
                    {AppUtils.formatDate(item.sending_time, "YYYY.MM.DD")}
                  </div>
                  <div className="space-y-1">
                    <div className="text-15 text-darkblue font-bold">
                      {item.title}
                    </div>
                    <div className="text-15 text-darkblue">{item.content}</div>
                  </div>
                </div>
                <div>
                  <img src={renderIcon(item.type)} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div
          className="flex justify-center items-center "
          style={{
            height: "calc(80vh - 100px)",
          }}
        >
          <div className="flex items-center justify-center flex-col px-5 w-full">
            <img src={AlertSvg} />
            <div className="mt-6 text-darkblue font-bold text-lg ">
              알림이 없어요.
            </div>
            <div className="mt-3 text-15 ">
              새로운 알림이 오면 알려드릴게요.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Notification;
